import { createQueryKeys } from '../../factories';

export const LOOKER_PROJECTS_NAMESPACE = ['databuilder', 'looker', 'projects'];
export const lookerProjectsQueryKeyFactory = createQueryKeys(
	LOOKER_PROJECTS_NAMESPACE
);
